<template>
  <v-form ref="form">
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            현재 비밀번호
            <span class="asterisk">*</span>
          </v-list-item-title>
          <v-text-field
            solo
            required
            autofocus
            ref="refCurrentPassword"
            placeholder="현재 비밀번호를 입력해 주세요"
            height="52"
            :append-icon="pwShow1 ? 'mdi-eye' : 'mdi-eye-off'" :type="pwShow1 ? 'text' : 'password'"
            @click:append="pwShow1 = !pwShow1"
            v-model="userData.currentPassword"
          />
        </v-list-item-content>
      </v-list-item>

      <PasswordForm :userData="userData" />

      <!-- 동의항목 추가 -->
      <!-- <WSSignUpAgree :userData="userData" v-if="$route.fullPath === '/tempChangePassword'"/> -->

      <v-btn color="primary" class="btn-text-white mb-5" x-large depressed block @click="clickSave">
        비밀번호 변경하기
      </v-btn>
    </v-list>
    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
  </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PasswordForm from "./comp/PasswordForm.vue";
import WSSignUpAgree from "../WS-SignUpAgree.vue";
import ConfirmDialog from "@/_zplabZPT/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: { PasswordForm, WSSignUpAgree, ConfirmDialog },
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      pwShow1: false,
    }
  },
  mounted() {
    // 라우터 확인
    // console.log("PasswordChangeForm mounted", this.$route.fullPath === "/tempChangePassword");
  },
  computed: {
    ...mapGetters(["isDev", "meInfo"]),
  },
  methods: {
    clickSave() {
      // 필수체크
      const $h = this.$helper;
      const DT = this.userData;
      const RF = this.$refs;

      let msg = `현재 비밀번호를 입력해주세요`;
      if (!$h.requiredCheck(DT.currentPassword, RF.refCurrentPassword, msg)) return;

      if (!RF.form.validate()) return;

      this.$refs.refConfirmDialog.open("비밀번호를 변경하시겠습니까?");
    },
    clickPopupConfirm() {
      const $h = this.$helper;
      const DT = this.userData;
      DT.endpoint = "changePassword";
      DT.endpointUser = "user";
      if(this.$route.fullPath === '/tempChangePassword') {
        DT.tempChangePassword = "Y";
      }
      this.saveDataQuery(DT).then((res) => {
        if (res === undefined) return;
        if (res.returnCode < 0) {
          this.$helper.showTostMessage("","현재 비밀번호가 일치하지 않습니다.","error");
          RF.refCurrentPassword.focus();
          return;
        }

        this.$helper.showTostMessage("","비밀번호 변경이 완료 되었습니다.<br/>새로운 비밀번호로 다시 로그인해주세요.","success");

        this.signOut();
        this.$router.push("/login");
      });

    },
    ...mapActions(["getMeInfo", "saveDataQuery", "signOut"]),
  },
};
</script>
